import * as React from 'react';

const RolesAndPermissions = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path
      fill="#fff"
      d="M3 20v-2.8c0-.567.146-1.087.438-1.563.291-.475.679-.837 1.162-1.087a14.843 14.843 0 0 1 3.15-1.163 13.76 13.76 0 0 1 4.25-.35c.333.025.667.063 1 .113-.067.967.108 1.88.525 2.737A5.376 5.376 0 0 0 15.35 18v2H3Zm16 3-1.5-1.5v-4.65a3.446 3.446 0 0 1-1.8-1.238c-.467-.608-.7-1.312-.7-2.112 0-.967.342-1.792 1.025-2.475A3.372 3.372 0 0 1 18.5 10c.967 0 1.792.342 2.475 1.025A3.372 3.372 0 0 1 22 13.5a3.31 3.31 0 0 1-.637 2c-.425.583-.963 1-1.613 1.25L21 18l-1.5 1.5L21 21l-2 2Zm-8-11c-1.1 0-2.042-.392-2.825-1.175C7.392 10.042 7 9.1 7 8s.392-2.042 1.175-2.825C8.958 4.392 9.9 4 11 4s2.042.392 2.825 1.175C14.608 5.958 15 6.9 15 8s-.392 2.042-1.175 2.825C13.042 11.608 12.1 12 11 12Zm7.5 2c.283 0 .52-.096.712-.287A.968.968 0 0 0 19.5 13a.968.968 0 0 0-.288-.713A.968.968 0 0 0 18.5 12a.968.968 0 0 0-.712.287.968.968 0 0 0-.288.713c0 .283.096.52.288.713.191.191.429.287.712.287Z"
    />
  </svg>
);

export default RolesAndPermissions;
